/**
 * useTrackEvent (V35.4) — Tracking d'événements custom
 *
 * Usage :
 *   import { trackEvent } from '../hooks/useTrackEvent';
 *   trackEvent('cta.become_member', { from: 'navigation' });
 *
 * Best-effort : ne lève jamais d'exception côté UI (fire-and-forget).
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Envoie un événement custom au backend.
 * @param {string} eventName  ex: "cta.become_member", "conversion.register_success"
 * @param {object} [properties] payload libre
 * @param {string} [userId] si connu
 */
export async function trackEvent(eventName, properties = {}, userId = null) {
  if (!eventName) return;
  try {
    await axios.post(`${BACKEND_URL}/api/admin/analytics/event`, {
      event_name: eventName,
      properties,
      user_id: userId,
    });
  } catch {
    // silencieux — le tracking ne doit jamais perturber l'expérience
  }
}

export default trackEvent;
